import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { translateKey } from '../../../../../translate';
import { FormDivider, UserTextParagraph } from '../../../../elements/common';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { DisplayWorkingDiagnosis } from '../../utils/v1/DisplayWorkingDiagnosis';
import { RequestThumbnails } from '../../utils/v1/RequestThumbnails';

export function TccrV1RequestSummary(props: ICustomControlRequestReadProps) {
    return (
        <>
            <DisplayWorkingDiagnosis
                diagnosisConclusion={props.request.customControlData?.conclusie_diagnose}
                diagnosisConsiderationIcd10={props.request.diagnosis?.diagnosisConsiderationIcd10 || null}
                thesaurusTermDate={props.request.dateSent}
                thesaurusTermId={props.request.diagnosis?.considerationThesaurusTermId || null}
            />

            {props.request.question && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('request.question')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.question}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <RequestThumbnails {...props} />
            <FormDivider />
        </>
    );
}
